export default __webpack_public_path__ + "static/sofa.inspirations-66157647efa16921190448882c8cb3e4.jpg";